import axios from "axios";

const customInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

customInstance.interceptors.request.use((config) => {
  if (typeof window !== "undefined") {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      // ลบ header Authorization ถ้ามี แต่ไม่มี token
      delete config.headers.Authorization;
    }
  }
  return config;
});

export default customInstance;
